import {
    QUESTION_POSITIONING,
    QUESTION_CLOSE_FILL,
    QUESTION_OPEN_FILL,
    QUESTION_OPEN_QUESTION,
    QUESTION_MULTIPLE_CHOICE,
    QUESTION_TRUE_FALSE
} from './constants/ConstantTypes';

// window.APP_CONFIG = window.APP_CONFIG || {};
export const AUTHORIZED_POSITIONS = process.env.REACT_APP_AUTHORIZED_POSITIONS
    ? process.env.REACT_APP_AUTHORIZED_POSITIONS.split(',')
    : [
          '216',
          '123',
          '050',
          '162',
          '117',
          '120',
          '186',
          '055',
          '114',
          '174',
          '180',
          '156',
          '063',
          '315',
          '312',
          '570',
          '144',
          '157',
          '163',
          '175',
          '114-1',
          '114-2',
          '186-1',
          '186-2'
      ];
export const NODE_ENV = process.env.REACT_APP_NODE_ENV || 'development';
export const AWS_AUDIO_PATH = process.env.REACT_APP_AWS_AUDIO_PATH || 'http://demo-creaverifiche.zanichelli.it/audio/';
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LcpghoTAAAAAPG1enSv6L1wFbusksj3k-mDR1qz';
export const S3_IMAGES_URL = process.env.REACT_APP_S3_IMAGES_URL || 'https://s3-eu-west-1.amazonaws.com/ckw-shared-data-dev/dev/item-media/Image/';
export const S3_T2P_PATH = process.env.REACT_APP_S3_T2P_PATH || 'https://s3-eu-west-1.amazonaws.com/za-upload-data-dev/t2p_file/';
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3456/api';
export const SP_URL = process.env.REACT_APP_SP_URL || 'http://localhost:3456';
export const HEART_BEAT_SCRIPT_URL = process.env.REACT_APP_HEART_BEAT_SCRIPT_URL || 'http://localhost:3456/idp-ping';
export const ZAINO_DIGITALE_URL = process.env.REACT_APP_ZAINO_DIGITALE_URL || '';
export const NEW_IDP_ENDPOINT = process.env.REACT_APP_NEW_IDP_ENDPOINT || 'http://localhost:3456';
export const IDP_ENV = process.env.REACT_APP_IDP_ENV || 'test';
export const GOOGLE_LOGIN = process.env.REACT_APP_GOOGLE_LOGIN || 'false';

// Google Analytics
export const GTM_CONTAINER_ID = process.env.REACT_APP_GTM_CONTAINER_ID || '';
export const GTM_OPTIMIZE_ID = process.env.REACT_APP_GTM_OPTIMIZE_ID || '';
export const GA_CONTAINER_ID = process.env.REACT_APP_GA_CONTAINER_ID || '';

export const X_API_ZANICHELLI = process.env.REACT_APP_X_API_ZANICHELLI || 'https://api.zanichelli.it/xapi';

export const FT_MAINTENANCE_PAGE =
    NODE_ENV === 'test' ? 'enable' : process.env.REACT_APP_FT_MAINTENANCE_PAGE ? process.env.REACT_APP_FT_MAINTENANCE_PAGE : 'disable';

export const EDITABLE_EXERCISE_TYPES = [
    QUESTION_OPEN_QUESTION,
    QUESTION_MULTIPLE_CHOICE,
    QUESTION_TRUE_FALSE,
    QUESTION_CLOSE_FILL,
    QUESTION_OPEN_FILL,
    QUESTION_POSITIONING
];

export const FEATURE_TOGGLE_NEW_PUBLIC_HOME = process.env.REACT_APP_FEATURE_TOGGLE_NEW_PUBLIC_HOME || 'enable';

export const ENABLED_CREATE_NEW_EXERCISE_TYPES_IDS = process.env.REACT_APP_ENABLED_CREATE_NEW_EXERCISE_TYPES_IDS
    ? JSON.parse(process.env.REACT_APP_ENABLED_CREATE_NEW_EXERCISE_TYPES_IDS)
    : [];

export const FEATURE_TOGGLE_EXERCISE_NO_SAVE = process.env.REACT_APP_FEATURE_TOGGLE_EXERCISE_NO_SAVE || 'disable';

export const WIP_MESSAGE =
    process.env.REACT_APP_WIP_MESSAGE ||
    'I contenuti di ZTE e Crea Verifiche sono su laZ Esercizi: uno strumento completo e aggiornato per lavorare con più semplicità.';
export const BUILD_YEAR = process.env.REACT_APP_BUILD_YEAR || '2020';
export const XAPI_LRS_ENV = process.env.REACT_APP_XAPI_LRS_ENV;
export const LRS_USERNAME = process.env.REACT_APP_LRS_USERNAME;
export const LRS_PASSWORD = process.env.REACT_APP_LRS_PASSWORD;
export const CURRENT_ENV = process.env.REACT_APP_CURRENT_ENV || '';
